module.exports = __webpack_public_path__ + "static/FireHorse-8a0f83314c547e8283a154d404f8d941.jpg";